import { GetInvoiceListQueryDto, InvoiceItem, PageDto } from '@ekt-group/general-purpose-api-interfaces';
import { queryOptions, useQuery } from '@tanstack/react-query';

import httpService from '@/lib/http.service';
import { QueryConfig } from '@/lib/react-query';

interface QueryParams extends GetInvoiceListQueryDto {
  contractIds: number[];
  invoiceNoLike?: string;
}

export const getInvoices = async (params: QueryParams) => {
  const { data } = await httpService.get<PageDto<InvoiceItem> | InvoiceItem[]>(`/invoices`, {
    params,
  });
  return data;
};

export const getInvoicesQueryOptions = (params: QueryParams) => {
  return queryOptions({
    queryKey: ['invoices', params],
    queryFn: () => getInvoices(params),
  });
};

type UseInvoicesOptions = {
  params: QueryParams;
  queryConfig?: QueryConfig<typeof getInvoicesQueryOptions>;
};

export const useGetInvoices = ({ params, queryConfig }: UseInvoicesOptions) => {
  return useQuery({
    ...getInvoicesQueryOptions(params),
    ...queryConfig,
  });
};
